import { ChanceManager } from 'managers/ChanceManager'
import { signal } from 'services/SignalsService'
import { StoreageService } from 'services/StoreageService'
import { spinSettings } from 'settings/custom/reels'
import { delay } from 'utils/Delay'

export default class ReelsEntity extends PIXI.Container {
  constructor() {
    super()
    this.spinModel = game.models.SpinModel.get()
    this.reels = []

    signal.on('ReelsEntity:START', this.start.bind(this))
    signal.on('ReelsEntity:RESPIN', this.respin.bind(this))
    signal.on('ReelsEntity:REFRESH', this.refresh)
  }

  refresh = (isFs) => {
    this.reels.forEach((reel) => {
      reel.refresh(isFs)
    })
  }

  start() {
    signal.dispatch('REELS-START')
    signal.dispatch('GAMBLE-FEATURE:HIDE-BUTTON')
    const time = StoreageService.get('turbo') ? spinSettings.minTurboTime : spinSettings.minSpinTime
    const minSpinTime = delay(time)
    const readyToStop = signal.promise('ACTION:REEL-SPIN')
    Promise.all([readyToStop, minSpinTime]).then(this.stop.bind(this))
    Promise.all(this.reels.map((reel) => reel.spin())).then(() => signal.dispatch('REELS-STOP'))
  }

  respin() {
    signal.dispatch('REELS-RESTART')
    const minSpinTime = delay(StoreageService.get('turbo') ? spinSettings.respin.time / 2 : spinSettings.respin.time)
    const readyToStop = signal.promise('ACTION:REEL-SPIN')
    const respinReels = spinSettings.respin.infinity ? this.reels : this.reels.filter((reel, id) => !this.spinModel.respin.includes(id))
    Promise.all([readyToStop, minSpinTime]).then(() => respinReels.map((reel) => reel.stop()))
    Promise.all(respinReels.map((reel) => reel.spin())).then(() => {
      signal.dispatch('REELS-STOP')
    })
  }

  stop() {
    this.reels[0].stop()
    for (let i = 1; i < this.reels.length; i++) {
      const resolveMoment = ChanceManager.check(i) && !ChanceManager.check(i - 1) ? 'END' : 'BEGIN'
      const time = delay(spinSettings.delayStop * i)
      const prev = signal.promise(`${resolveMoment}-STOP-REEL|${i - 1}`)
      Promise.all([time, prev]).then(() => this.reels[i].stop())
    }
  }

  register = (type, object) => {
    if (type === 'Reel') {
      this.reels.push(object)
    }
  }
}
